import { useState } from 'react';
import { Box, Typography, Stack, TextField, Alert } from '@mui/material';
import { navigate, nextParam } from '../../lib/navigation';
import AuthPageLayout from '../../components/AuthPageLayout';
import Button from '../../components/Button';
import FloatingHelpButton from '../../components/FloatingHelpButton';

function LoginPage({ authActions }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const next = nextParam();

  async function submit(event) {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await authActions.login(email, password);
      navigate(next || '/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthPageLayout variant="login">
      <Typography variant="h4" fontWeight={700} sx={{ fontSize: '1.75rem', mb: 0.75 }}>
        Welcome back
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Log in to manage your CreatorCV.
      </Typography>
      <Box component="form" onSubmit={submit}>
        <Stack spacing={2}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField fullWidth label="Email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} required />
          <TextField fullWidth label="Password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} required />
          <Button type="submit" disabled={submitting} sx={{ py: 1.25 }}>
            {submitting ? 'Logging in…' : 'Log in'}
          </Button>
        </Stack>
      </Box>
      <Typography sx={{ mt: 3 }} color="text.secondary">
        Don't have an account?{' '}
        <Box
          component="span"
          sx={{ color: 'primary.main', cursor: 'pointer', fontWeight: 600 }}
          onClick={() => navigate(`/signup${next ? `?next=${encodeURIComponent(next)}` : ''}`)}
        >
          Create your CreatorCV
        </Box>
      </Typography>
      <FloatingHelpButton />
    </AuthPageLayout>
  );
}

export default LoginPage;
